import { render, staticRenderFns } from "./LogGeracaoList.vue?vue&type=template&id=238e7c5b"
import script from "./LogGeracaoList.vue?vue&type=script&lang=js"
export * from "./LogGeracaoList.vue?vue&type=script&lang=js"
import style0 from "./LogGeracaoList.vue?vue&type=style&index=0&id=238e7c5b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports